import React, { Component } from 'react'; 

class dinoiluminado extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
    <div className="container mt-5 mb-5 pt-5 pagina-dino">

      {/* Encabezado */}
      <div className="text-center mb-5">
        <h1 className="titulo-dino">Dinoparque Iluminado</h1>
        <p className="lead subtitulo-dino">
          Un recorrido navideño entre dinosaurios, luces y magia familiar.
        </p>
      </div>

      {/* Información principal */}
      <div className="row text-center mb-5">
        <div className="col-md-4 mb-3">
          <div className="info-box p-3 rounded">
            <h4>
              <span role="img" aria-label="horario">⏰</span> Horario
            </h4>
            <p> Taquillas 5:30 pm – 8:30 pm</p>
            <p className="small">(Permanencia hasta 9:30 pm)</p>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="info-box p-3 rounded">
          <h4>
            <span role="img" aria-label="fechas">📅</span> Fechas
          </h4>
            <p>Del 2 de diciembre al 11 de enero</p>
            <p><b>Reyes Magos</b> del 2 al 5 de enero de 6:00 p.m. a 9:00 p.m.</p>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="info-box p-3 rounded">
            <h4>
              <span role="img" aria-label="costos">🎟️</span> Costos
            </h4>
            <p>Niños: <b>$66 MXN</b></p>
            <p>Adultos: <b>$74 MXN</b></p>
          </div>
        </div>
      </div>

      {/* Actividades */}
      <h3 className="text-center mb-4">Actividades Incluidas</h3>

      <div className="row g-4">

        <div className="col-md-3 col-6">
          <div className="card actividad">
            <div className="card-body text-center">
              <div className="icono">
                <span role="img" aria-label="dinosaurio">🦖</span>
              </div>
              <h5>Recorrido Iluminado</h5>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-6">
          <div className="card actividad">
            <div className="card-body text-center">
              <div className="icono">
                <span role="img" aria-label="pista de hielo">⛸️</span>
              </div>
              <h5>Pista de Hielo</h5>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-6">
          <div className="card actividad">
            <div className="card-body text-center">
              <div className="icono">
                <span role="img" aria-label="árbol navideño">🎄</span>
              </div>
              <h5>Villa Navideña</h5>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-6">
          <div className="card actividad">
            <div className="card-body text-center">
              <div className="icono">
                <span role="img" aria-label="cámara">📸</span>
              </div>
              <h5>Fotos con Los Reyes Magos</h5>
            </div>
          </div>
        </div>
      </div>

     
    </div>
        ); 
    } 
} 

export default dinoiluminado;

